// /opt/isp_erp/frontend/src/components/tickets/UbicacionCliente.jsx
import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import NavigationIcon from '@mui/icons-material/Navigation';
import MapIcon from '@mui/icons-material/Map';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import axios from '../../api/axios';

const ORIGEN = {
  cliente: 'GPS guardado del cliente (lo toma el celular al cerrar un ticket)',
  ticket: 'GPS guardado en el ticket',
  instalacion: 'Coordenadas de la instalación',
};

const valida = (lat, lon) => {
  const a = Number(lat);
  const b = Number(lon);
  return lat !== null && lat !== undefined && lon !== null && lon !== undefined &&
    Number.isFinite(a) && Number.isFinite(b) && Math.abs(a) <= 90 && Math.abs(b) <= 180 && !(a === 0 && b === 0);
};

const UbicacionCliente = ({ ticket }) => {
  const [ubicacion, setUbicacion] = useState(null);
  const [cargando, setCargando] = useState(false);
  const ticketId = ticket?.id;
  const estado = ticket?.status;
  const clienteId = ticket?.customer_id;

  useEffect(() => {
    if (!ticketId) return undefined;
    let vigente = true;
    setCargando(true);
    axios.get(`/tickets/${ticketId}/ubicacion`)
      .then((r) => { if (vigente) setUbicacion(r.data); })
      .catch(() => { if (vigente) setUbicacion(null); })
      .finally(() => { if (vigente) setCargando(false); });
    return () => { vigente = false; };
  }, [ticketId, estado, clienteId]);

  const lat = ubicacion ? ubicacion.latitud : ticket?.latitude;
  const lon = ubicacion ? ubicacion.longitud : ticket?.longitude;
  const direccion = ((ubicacion && ubicacion.direccion) || ticket?.customer_address || '').trim();
  const hayGps = valida(lat, lon);

  if (!hayGps && !direccion) return null;

  const destino = hayGps ? `${Number(lat)},${Number(lon)}` : encodeURIComponent(direccion);
  const urlRuta = `https://www.google.com/maps/dir/?api=1&destination=${destino}&travelmode=driving`;
  const urlMapa = `https://www.google.com/maps/search/?api=1&query=${destino}`;

  return (
    <Box sx={{ my: 1.5, p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1, bgcolor: 'action.hover' }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
        <LocationOnIcon color="primary" fontSize="small" />
        <Typography variant="subtitle2">Ubicación del cliente</Typography>
        {cargando && <CircularProgress size={14} />}
      </Stack>
      {hayGps ? (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
          {ORIGEN[ubicacion?.fuente] || 'Coordenadas registradas'} · {Number(lat).toFixed(6)}, {Number(lon).toFixed(6)}
        </Typography>
      ) : (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
          Este cliente todavía no tiene GPS guardado (se guarda al cerrar su primer ticket). Mientras tanto el mapa busca por la dirección registrada.
        </Typography>
      )}
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <Button variant="contained" size="small" startIcon={<NavigationIcon />} href={urlRuta} target="_blank" rel="noopener noreferrer">
          Cómo llegar
        </Button>
        <Button variant="outlined" size="small" startIcon={<MapIcon />} href={urlMapa} target="_blank" rel="noopener noreferrer">
          Ver en el mapa
        </Button>
      </Stack>
    </Box>
  );
};

export default UbicacionCliente;
